import { render, staticRenderFns } from "./Battle.vue?vue&type=template&id=72e32ee4&"
import script from "./Battle.vue?vue&type=script&lang=js&"
export * from "./Battle.vue?vue&type=script&lang=js&"
import style0 from "./Battle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports